import { Box, Grid, Stack, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import * as React from 'react';
import * as Redux from 'react-redux';
import {
  BLUE_COLOR,
  GREEN_COLOR,
  RED_COLOR,
} from '../../../../../../constants/ColorsConst';
import { toPorcentajeHelper } from '../../../../../../helpers';
import { useNotification } from '../../../../../../helpers/Notification';
import BotonComponent from '../../../../../dashboard/components/BotonNuevo';
import { setActivoPevaActividadesAction } from '../../../peva_actividades/PevaActividadesAction';
import { setActivoPlanevaTemasAction } from '../../../planeva_temas/PlanevaTemasAction';
import {
  deletePtemEvaluacionesAction,
  setActivoPtemEvaluacionesAction,
} from '../../../ptem_evaluaciones/PtemEvaluacionesAction';
import { setDetallesPlanEvaluacionAction } from '../../PlanEvaluacionAction';
import ActividadesPlanEvaluacion from './ActividadesPlanEvaluacion';

const EvaluacionesPlanEvaluacion = ({
  isEdit,
  setOpenModalForm,
  isDesc = false,
  setTipo,
  planEvaluacion,
  tema,
}) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const planEvaluacionStore = Redux.useSelector(
    (state) => state.planEvaluacion,
  );
  const ptemEvaluacionesStore = Redux.useSelector(
    (state) => state.ptemEvaluaciones,
  );
  const pevaActividadesStore = Redux.useSelector(
    (state) => state.pevaActividades,
  );

  const botonAddActividad = (tema, el) =>
    isEdit && (
      <BotonComponent
        click={async () => {
          setTipo(2);
          setActivoPlanevaTemasAction(dispatch, tema);
          setActivoPtemEvaluacionesAction(dispatch, el);
          setActivoPevaActividadesAction(dispatch, null);
          setOpenModalForm(true);
        }}
        sx={{
          fontSize: '10pt',
        }}
        green={true}
        text="AGREGAR ACTIVIDAD"
        addIcon
      />
    );

  function showBotonActividad(data) {
    let total = 0;
    data.instrumentos.forEach((el) => {
      total = total + Number(el.ponderacion);
    });
    return total === Number(data.ponderacion);
  }

  return (
    <Grid container spacing={1}>
      {tema.evaluaciones.map((el) => (
        <Grid key={`tema-${el.id}`} item xs={12} md={12}>
          <Box
            sx={{
              borderRadius: '10px',
              p: 1,
              border:
                ptemEvaluacionesStore.activo?.id === el.id &&
                !pevaActividadesStore.activo
                  ? `solid 2px ${
                      planEvaluacionStore.detalles.deleteEvaluacion
                        ? RED_COLOR
                        : BLUE_COLOR
                    }`
                  : `solid 1px ${grey[500]}`,
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ mb: el.evaluacion.desc ? 0 : 1 }}
            >
              <Stack direction="row" alignItems="center">
                <Typography
                  sx={{ fontSize: '8pt', fontWeight: 'bold', mr: 0.5 }}
                >
                  Evaluación:
                </Typography>
                <Typography sx={{ fontWeight: 'bold', color: GREEN_COLOR }}>
                  {el.evaluacion.nombre}
                </Typography>
              </Stack>
              <Stack direction="row" alignItems="end">
                <Typography sx={{ fontWeight: 'bold', fontSize: 16, mr: 1 }}>
                  {toPorcentajeHelper(
                    el.ponderacion,
                    100,
                    entidadesStore.ajustes.ponderacion,
                  )}
                  %
                </Typography>
                <Typography sx={{ fontWeight: 'bold', fontSize: 16, mr: 1 }}>
                  {el.ponderacion} Pts
                </Typography>
              </Stack>
            </Stack>
            {!isDesc ? null : el.desc ? (
              <Typography sx={{ mb: 1 }}>{el.desc}</Typography>
            ) : (
              el.evaluacion.desc && (
                <Typography sx={{ mb: 1 }}>{el.evaluacion.desc}</Typography>
              )
            )}

            <ActividadesPlanEvaluacion
              isEdit={isEdit}
              setOpenModalForm={setOpenModalForm}
              isDesc={isDesc}
              setTipo={setTipo}
              planEvaluacion={planEvaluacion}
              evaluacion={el}
            />

            {isEdit && (
              <Stack alignItems="flex-end" sx={{ mt: 1 }}>
                {planEvaluacionStore.detalles.deleteEvaluacion &&
                ptemEvaluacionesStore.activo?.id === el.id ? (
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography variant="body1" color="initial">
                      {' '}
                      Seguro que desea eliminar esta evaluación
                    </Typography>
                    <BotonComponent
                      click={async () => {
                        await deletePtemEvaluacionesAction(
                          { dispatch, notify },
                          planEvaluacion.id,
                          el.id,
                        );
                        setDetallesPlanEvaluacionAction(dispatch, null, null);
                        setActivoPtemEvaluacionesAction(dispatch, null);
                      }}
                      green
                      text="SI"
                      checkIcon
                    />
                    <BotonComponent
                      click={() => {
                        setActivoPtemEvaluacionesAction(dispatch, null);
                        setDetallesPlanEvaluacionAction(dispatch, null, null);
                      }}
                      red
                      text="NO"
                      closeIcon
                    />
                  </Stack>
                ) : (
                  <Stack direction="row" spacing={1}>
                    {!showBotonActividad(el) && botonAddActividad(tema, el)}
                    <BotonComponent
                      click={() => {
                        setActivoPtemEvaluacionesAction(dispatch, el);
                        setTipo(1);
                        setOpenModalForm(true);
                        setDetallesPlanEvaluacionAction(dispatch, null, null);
                        setActivoPlanevaTemasAction(dispatch, tema);
                      }}
                      blue
                      text="EDITAR"
                      editIcon
                    />
                    <BotonComponent
                      click={() => {
                        setActivoPtemEvaluacionesAction(dispatch, el);
                        setDetallesPlanEvaluacionAction(
                          dispatch,
                          'deleteEvaluacion',
                          true,
                        );
                        setActivoPlanevaTemasAction(dispatch, null);
                        setActivoPevaActividadesAction(dispatch, null);
                      }}
                      red
                      text="ELIMINAR"
                      deleteIcon
                    />
                  </Stack>
                )}
              </Stack>
            )}
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default EvaluacionesPlanEvaluacion;
